import { Component, OnDestroy, OnInit, Input, Renderer2 } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ImageSize, VideoInfoRaw } from '../video-library.model';
import { VideoLibraryService } from '../video-library.service';

@Component({
  selector: 'app-workout-preview',
  templateUrl: './workout-preview.component.html',
  styleUrls: ['./workout-preview.component.scss'],
})
export class WorkoutPreviewComponent implements OnInit,OnDestroy {
  environmentKey: string;
  poster: string;
  dataSetup: string;
  customClass:any;
  playbackId:string;
  player: HTMLCollection;
  @Input() videoInfo: VideoInfoRaw;
  constructor(
    private renderer: Renderer2,
    private vdoLibraryService: VideoLibraryService
    ) { 
  }

  ngOnInit(): void {
    this.renderExternalScript('https://unpkg.com/@mux/videojs-kit@latest/dist/index.js').onload = () => {
      console.log('@mux/videojs-kit Script loaded');
      this.loadCSS();
      setTimeout(() => {
        this.loadCustomStyle();
      },1);      
    }
    this.getPoster();
    this.playbackId = this.videoInfo.attributes.muxAsset?.data?.attributes.playback_id||'';
    this.environmentKey = environment.envkey_mux;
    this.dataSetup = `{
      "controlBar": {"pictureInPictureToggle": false},
      "timelineHoverPreviews": true,
      "plugins": {
        "mux": {
          "debug": true,
          "data": {
            "env_key": "${this.environmentKey}",
            "video_title": "${this.videoInfo.attributes.title?this.videoInfo.attributes.title:this.videoInfo.attributes.muxAsset?.data?.attributes.title}"
          }
        }
      }
    }`;
  }

  ngOnDestroy(): void {
    this.disposeVideoJs();
  }

  loadCustomStyle(){
    this.customClass = document.getElementsByClassName("vjs-poster");
    if(this.customClass[0]) this.customClass[0].style.backgroundSize = "cover";
    document.getElementsByClassName("vjs-picture-in-picture-control")[0].remove();
  
  }

  renderExternalScript(src: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.async = true;
    script.defer = true;
    this.renderer.appendChild(document.body, script);
    return script;
  }

  disposeVideoJs(): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML=`videojs('lfdo-workout-preview').dispose();`;
    this.renderer.appendChild(document.body, script);
    return script;
  }

  loadCSS() {
    // Create link
    const link = document.createElement('link');
    link.href = 'https://unpkg.com/@mux/videojs-kit@latest/dist/index.css';
    link.rel = 'stylesheet';
    link.type = 'text/css';
    
    const head = document.getElementsByTagName('head')[0];
    const links = head.getElementsByTagName('link');
    const style = head.getElementsByTagName('style')[0];
    
    // Check if the same style sheet has been loaded already.
    let isLoaded = false;  
    for (let i = 0; i < links.length; i++) {
      const node = links[i];
      if (node.href.indexOf(link.href) > -1) {
        isLoaded = true;
      }
    }
    if (isLoaded)return;
    head.insertBefore(link, style);
  }

  private getPoster() { 
    this.poster = this.videoInfo?.attributes?.displayWorkoutImage?.url || '';
  }
}
